import type { ReactNode, JSX} from "react";
import { cn, pClass } from "./cn";

export interface CardProps {
  /** Uniform padding (Tailwind spacing scale) */
  readonly p?: number;
  /** Reduce opacity (e.g. completed state) */
  readonly dimmed?: boolean;
  /** Border radius variant */
  readonly rounded?: "md" | "lg" | "xl";
  /** Extra className (margins only) */
  readonly className?: string;
  readonly children: ReactNode;
}

const roundedMap: Readonly<Record<string, string>> = {
  md: "rounded-md",
  lg: "rounded-lg",
  xl: "rounded-xl",
};

export function Card({
  p = 4,
  dimmed,
  rounded = "xl",
  className,
  children,
}: CardProps): JSX.Element {
  return (
    <div
      className={cn(
        "bg-surface-secondary border border-edge",
        roundedMap[rounded],
        pClass(p),
        dimmed && "opacity-70",
        className,
      )}
    >
      {children}
    </div>
  );
}
